export const ConnectionMode = [
  'single',
  'dual'
]
